import { gql } from '@apollo/client'
import { GET_EDUCATIONAL_PARTNERS_DATA } from 'src/actions'
import { dispatchQueryGQL } from '../../gqlActions'

const GET_EDUCATIONAL_PARTNERS = gql`
  query GetEducationalPartners {
    getEducationalPartners {
      academyName
      country
      creation_date
      email
      lat
      lng
      location
      phone
      web
    }
  }
`

export const getEducationalPartnersGQL = () => {
  return dispatchQueryGQL({
    query: GET_EDUCATIONAL_PARTNERS,
    type: GET_EDUCATIONAL_PARTNERS_DATA,
    key: 'getEducationalPartners'
  })
}
